import { getClassNames } from '@websolutespa/bom-core';
import { LlmHistory } from '@websolutespa/bom-mixer-llm';
import { ChevronDownIcon } from 'lucide-react';
import { useState } from 'react';
import style from './history-group.module.scss';
import { HistoryItem } from './history-item';

export type IHistoryGroup = {
  id: string;
  title: string;
  items: LlmHistory[];
};

export type HistoryGroupProps = {
  group: IHistoryGroup;
};

export const HistoryGroup: React.FC<HistoryGroupProps> = ({ group }) => {
  const [open, setOpen] = useState(true);
  return (
    <div key={group.id} className={getClassNames(style.group, { [style.open]: open })}>
      <button className={style.head} type="button" onClick={() => setOpen(!open)}>
        <div className={style.title}>{group.title}</div>
        <div className={style.actions}>
          <div className={style.count}>{group.items.length}</div>
          <div className={style.icon}>
            <ChevronDownIcon />
          </div>
        </div>
      </button>
      <div className={style.items}>
        {group.items.map((item, i) => (
          <HistoryItem key={`history-${i}`} item={item} />
        ))}
      </div>
    </div>
  );
};
